import React, { useEffect, lazy } from 'react';
import PropTypes from 'prop-types';

import CodeSplit from '../../components/common/code.split';
import USER_TYPES from '../../../mobile/shared/constants/user.types';

import Login from '../login';
import styles from './styles.scss';

const Admin = lazy(() => import('./admin'));
const Partner = lazy(() => import('./partner'));
const Customer = lazy(() => import('./customer'));

export default function Root({ user, getUsers, clearSession }) {
  useEffect(() => {
    if (user && user.type === USER_TYPES.support) {
      //TODO paginate or populate from API on linked models (devices, partners)
      getUsers();
    }
  }, [user]);
  let body = <Login />;
  if (user && user.type === USER_TYPES.support) {
    body = CodeSplit(Admin, { user, clearSession });
  } else if (user && user.type === USER_TYPES.provider && user.providerId) {
    body = CodeSplit(Partner, { user, clearSession });
  } else if (user) {
    body = CodeSplit(Customer, { user, clearSession });
  }
  return <div className={styles.root}>{body}</div>;
}
Root.defaultProps = {
  user: null,
  clearSession: () => null,
};
Root.propTypes = {
  getUsers: PropTypes.func.isRequired,
  clearSession: PropTypes.func.isRequired,
  user: PropTypes.shape({
    type: PropTypes.string,
  }),
};
Root.defaultProps = {
  user: null,
};
